<template>
  <div class="row">
    <div class="col col-12">
      {{param}}
      <input class="form-control" readonly :value="value">
    </div>
    <div class="col-md-2 mt-1">
      <div class="btn-group">
        <button
          class="btn btn-outline-secondary"
          v-b-tooltip="'Editar en linea'"
          v-if="hasPermisionSave"
          @click="openEditHtml"
        >
          <span class="material-icons">edit</span>
        </button>
        <DownloadS3File
          :path="value"
          :name="param+'.html'"
          :force="'si'"
          style-class="btn btn-outline-secondary"
          v-b-tooltip="'Descargar'"
        >
          <template slot="body" slot-scope="props">
            <span class="material-icons" v-if="!props.downloading">cloud_download</span>
            <b-spinner
              v-if="props.downloading"
              variant="primary"
              size="18"
            />
          </template>
        </DownloadS3File>
        <UploadFileToS3
          @input="uploadLocalFile"
          :upload-to="attachmentUrl"
          :accept="'text/html'"
          v-b-tooltip="'Cargar'"
          v-if="hasPermisionSave"
        >
          <template slot="button" slot-scope="props">
            <button
              class="btn btn-outline-secondary"
              :disabled="props.progress.enabled"
            >
              <span class="material-icons">cloud_upload</span>
            </button>
          </template>
        </UploadFileToS3>
      </div>
    </div>
    <b-modal
      id="modalEdit"
      ref="modalEdit"
      title="Editor online"
      size="xl"
      hide-footer
    >
      <b-spinner
        v-if="loadContent"
        variant="primary"
        size="18"
      />
      <b-card-text v-if="!loadContent">
        <div class="preview">
          <div class="row">
            <div class="col-12 col-md-12">
              <vue-json-editor
                v-model="content"
                mode="code"
                :modes="['code']"
                :show-btns="false"
                :exapndedOnStart="true"
              />
            </div>
          </div>
        </div>
      </b-card-text>
      <vs-progress
        v-if="progress.enabled"
        :percent="progress.percent"
        :indeterminate="progress.indeterminate"
        :color="color"
      />
      <div class="text-center" v-if="!loadContent">
        <button class="btn" @click="changeHtmlEditor">
          Aceptar
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { uuid } from 'vue-uuid';
import vueJsonEditor from 'vue-json-editor';

import DownloadS3File from '@/febos/global/empresas/componentes/configs/inputs/DownloadS3File';
import UploadFileToS3 from '@/febos/global/empresas/componentes/configs/inputs/UploadFileToS3';
import {
  ioDownloadContentPrivateFile,
  ioGetPrivateUploadUrl, ioUploadFileToPrivateUrl
} from '@/febos/servicios/api/herramientas.api';
import InputConfigMixin from '@/febos/global/empresas/componentes/configs/inputs/InputConfigMixin';

export default {
  name: 'ConfigInputS3Json',
  mixins: [InputConfigMixin],
  components: {
    UploadFileToS3, DownloadS3File, vueJsonEditor
  },
  data: () => ({
    loadContent: false,
    viewHtml: false,
    content: {},
    progress: {
      enabled: false,
      percent: 0,
      indeterminate: true
    }
  }),
  computed: {
    editor() {
      return this.$refs.myTextEditor.quill;
    },
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    ...mapGetters('Empresas', [
      'company'
    ])
  },
  mounted() {
    this.valueMutable = this.value;
  },
  methods: {
    input(newValue) {
      this.content = newValue;
    },
    async uploadLocalFile({ path }) {
      this.$emit('input', path);
    },
    async changeView() {
      this.viewHtml = !this.viewHtml;
    },
    async openEditHtml() {
      this.viewHtml = true;
      this.loadContent = true;
      this.$refs.modalEdit.show();
      try {
        this.loadContent = true;
        const data = await ioDownloadContentPrivateFile(this.value);
        this.content = JSON.parse(data);
      } finally {
        this.loadContent = false;
      }
    },
    async changeHtmlEditor() {
      this.loadContent = true;
      try {
        const fileId = uuid.v1();
        const baseUrl = this.attachmentUrl;
        const finalUrl = `${baseUrl}${Date.now()}${fileId}.json`;
        const response = await ioGetPrivateUploadUrl(finalUrl, 'text/html');
        const content = JSON.stringify(this.content);
        const blob = new Blob([content], {
          type: 'text/json'
        });
        await ioUploadFileToPrivateUrl(
          response.data?.url,
          blob,
          (percent) => {
            this.progress.percent = percent;
          }
        );
        this.$emit('input', finalUrl);
        this.$refs.modalEdit.hide();
      } finally {
        this.loadContent = false;
      }
    }
  },
  props: {
    value: {
      type: String,
      required: false,
    }
  }
};
</script>
<style scoped>

</style>
